import styled from 'styled-components';
export var OrderList = styled.div.withConfig({
  displayName: "DirectionListstyles__OrderList",
  componentId: "keen-query-creator__sc-xd9fwu-0"
})(["&&&{width:auto;}"]);
export var Container = styled.div.withConfig({
  displayName: "DirectionListstyles__Container",
  componentId: "keen-query-creator__sc-xd9fwu-1"
})(["&&&{position:relative;}"]);